import React, { useEffect } from "react";
import { FormSpy } from "react-final-form";
import ReactGA from "react-ga";

import useZipCodeValidation from "./hooks/useZipCodeValidation";
import Wizard from "./components/Wizard";
import YourDetails from "./sections/YourDetails";
import YourMove from "./sections/YourMove";
import Estimate from "./sections/Estimate";
import Book from "./sections/Book";
import Survey from "./sections/Survey";
import Fade from "./animate/Fade";

import "./styles/index.scss";
import ContactConfirmation from "./sections/ContactConfirmation";

ReactGA.initialize("UA-1505756-2");

ReactGA.event({
  category: "Move Calculator",
  action: "Step",
  label: "Your Move",
});

const App = () => {
  const zipCodeValidation = useZipCodeValidation();
  useEffect(
    () =>
      new ResizeObserver(() =>
        window.parent.postMessage(
          {
            type: "resize",
            height: document.body.scrollHeight,
          },
          "*"
        )
      ).observe(document.body),
    []
  );
  return (
    <Fade show>
      <div className="App" id="moving-calculator">
        <Wizard>
          <Wizard.Page validate={zipCodeValidation}>
            <YourMove />
          </Wizard.Page>
          <Wizard.Page>
            <YourDetails />
          </Wizard.Page>
          <Wizard.Page>
            <FormSpy subscription={{ values: true }}>
              {({ values }) =>
                values.international || values.live_in === "other" ? (
                  <ContactConfirmation />
                ) : (
                  <Estimate />
                )
              }
            </FormSpy>
          </Wizard.Page>
          <Wizard.Page>
            <FormSpy subscription={{ values: true }}>
              {({ values }) =>
                values.estimateActions === "book" ? (
                  <Book />
                ) : (
                  <ContactConfirmation />
                )
              }
            </FormSpy>
          </Wizard.Page>
          <Wizard.Page>
            <Survey />
          </Wizard.Page>
        </Wizard>
      </div>
    </Fade>
  );
};

export default App;
